import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import RevenueCalculator from 'molecules/RevenueCalculator/RevenueCalculator';
import useStandardPlansRevenueCalculatorController from 'src/hooks/RevenueCalculator/useStandardPlansRevenueCalculatorController';

const PLAN_FOOTNOTES = {
  launch: {
    text: 'Based on average earnings for Hosts across the Launch Plan. Results vary.',
  },
  scale: {
    text: 'Based on average earnings for Hosts across the Scale Plan. Results vary.',
  },
  growth: {
    text: 'Based on average earnings for Hosts across the Growth Plan. Results vary.',
  },
};

const BusinessRevenueCalculator = (): JSX.Element => {
  const { selectedPlan, ...calculatorProps } = useStandardPlansRevenueCalculatorController();

  return (
    <Stack
      direction='column'
      gap='spacing-7xl'
      justify='center'
      align='center'
    >
      <HeadingAndSupportingText
        maxWidth='width-lg'
        gap='spacing-3xl'
        heading={{
          type: 'heading',
          size: 'xl',
          fontWeight: 'font-weight-semibold',
          textAlign: 'center',
          text: 'What you can earn',
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          textAlign: 'center',
          color: 'text-tertiary',
          text: "The typical host on our Launch Plan earns $4,800/year. Adjust the numbers to see what's possible for you.",
        }}
      />
      <RevenueCalculator
        {...calculatorProps}
        helperText={{
          ...PLAN_FOOTNOTES[selectedPlan],
          type: 'paragraph',
          size: 'xs',
          color: 'text-primary',
        }}
      />
    </Stack>
  );
};

export default BusinessRevenueCalculator;
